
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import TitleBar from '../../components/uiParts/TitleBar';
import MenuIcon from '../../components/uiParts/MenuIcon';
import { useAuth } from '../../contexts/AuthContext';

const BidMastaMenu = () => {
    
    const { authInfo } = useAuth();
    const navigate = useNavigate();

	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
    // initialize - セッション情報を取得
	//-----------------------------------------------
    const facilityCode   = authInfo.facilityCode;
    const facilityName   = authInfo.facilityName;
    const loginUserId    = authInfo.userId;
    const loginUserName  = authInfo.userName;
    const lobinAuthority = authInfo.authority;
    
	//===============================================
	// イベントハンドラ
	//===============================================
    const handleClick = (url) => {
        navigate(url);
    };
	//-----------------------------------------------
    // eventHandler - 日付の変更
	//-----------------------------------------------
    const handleChange_entryDate = (value) => {
    };
	//===============================================
	// JSXのレンダー
	//===============================================
    return (
        <>
        <Header loginInfo="on" backButton="on" backPage="/home" setEntryDate={handleChange_entryDate} />
            <div className='menu' style={{paddingTop:'2px', paddingLeft:'10px', paddingRight:'10px', paddingBottom:'10px'}}>
                <div>
                    <TitleBar title="荷受けマスタメニュー①" />
                    <MenuIcon header="maintenance Menu" title="荷主マスタ"  onClick={() => handleClick('/shipList')}>
                        <SettingsApplicationsIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="maintenance Menu" title="魚種マスタ"  onClick={() => handleClick('/originalFishSpecList')}>
                        <SettingsApplicationsIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="maintenance Menu" title="規格マスタ"  onClick={() => handleClick('/standardList')}>
                        <SettingsApplicationsIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                </div>
                <div>
                    <TitleBar title="荷受けマスタメニュー②" />
                    <MenuIcon header="maintenance Menu" title="漁法マスタ"  onClick={() => handleClick('/fishMethodList')}>
                        <SettingsApplicationsIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="maintenance Menu" title="荷受けメモマスタ"  onClick={() => handleClick('/memoList')}>
                        <SettingsApplicationsIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="maintenance Menu" title="水槽マスタ"  onClick={() => handleClick('/danbeList')}>
                        <SettingsApplicationsIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                </div>
                <div>
                    <TitleBar title="入札マスタメニュー" />
                    <MenuIcon header="maintenance Menu" title="仲買人マスタ"  onClick={() => handleClick('/traderList')}>
                        <SettingsApplicationsIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="maintenance Menu" title="セリ人マスタ"  onClick={() => handleClick('/bidPersonList')}>
                        <SettingsApplicationsIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="maintenance Menu" title="入札条件マスタ"  onClick={() => handleClick('/commentList')}>
                        <SettingsApplicationsIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                </div>
            </div>
        </>
    )
}
export default BidMastaMenu;